var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree3Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.83 145.11",
    style: {
      enableBackground: "new 0 0 121.83 145.11"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.td30{fill:#D4D3D7;}\n\t.td31{fill:#6C401D;}\n\t.td32{fill:#945225;}\n\t.td33{fill:#0B8545;}\n\t.td34{fill:#0C6A37;}\n\t.st0{transform-origin: 50% 50%; transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st4{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 td30",
    cx: 60.47,
    cy: 139.46,
    rx: 31.4,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1 td31",
    points: "65.62,81.59 56.21,81.59 52.21,140.2 69.62,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2 td32",
    points: "60.91,140.2 69.62,140.2 65.62,81.59 60.91,81.59  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 td31",
    d: "M84.04,79.74c0,0-11.58,13.54-21.14,17.23v-3.84c8.04-3.55,18.68-13.03,18.68-13.03L84.04,79.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3 td33",
    d: "M109.42,31.52c-1.3-12-16.47-20.98-26.37-19.58C82.36,3.7,70.26,0,60.92,0C50.66,0,39.15,3.84,37.19,12.07 c-8.15-1.9-24.14,6.93-23.11,19.4C5.15,32.31,0,44.03,0,51.38c0,8.93,3.94,17.02,16.77,17.95C22.26,78.91,41,82.41,60.92,82.41 c19.25,0,37.91-5.08,43.3-13.08c12.19-1.4,17.62-9.58,17.62-17.95C121.83,44.96,121.15,35.66,109.42,31.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 td34",
    d: "M60.92,68.91c-23.12,0-43.76-4.19-60.11-11.13c1.38,5.16,5.39,10.72,15.97,11.55 c5.6,9.6,24.21,13.08,44.14,13.08c19.03,0,37.93-5.1,43.3-13.08c8.12-0.91,14.15-5.2,16.48-11.55 C104.35,64.72,84.04,68.91,60.92,68.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree3Dark);
export default __webpack_public_path__ + "static/media/tree3_dark.2b64a9b8d20512bb3447e0fa4b598fa1.svg";
export { ForwardRef as ReactComponent };